import { render, staticRenderFns } from "./part_base_dialog.vue?vue&type=template&id=8e006428"
import script from "./part_base_dialog.vue?vue&type=script&lang=js"
export * from "./part_base_dialog.vue?vue&type=script&lang=js"
import style0 from "./part_base_dialog.vue?vue&type=style&index=0&id=8e006428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports